import { useState } from "react";

// ======================
// PRISDATA (FASTSAT TIL 2026)
// ======================
const priceSets = {
  2026: {
    TILKNYTNING: {
      label: "Særlig tilknytning til sognet",
      help: "Tidligere bopæl i sognet, nære pårørende i sognet eller ægtefælle/forældre/børn begravet på kirkegården.",
      urne: { erhvervelse: 177, pleje: 786, nedsaettelse: 524 },
      kiste: { erhvervelse: 286, pleje: 1092, nedsaettelse: 3537 },
    },
    BOSAT: {
      label: "Bosat i provstiet og medlem af folkekirken",
      help: "Medlemmer af folkekirken med bopæl i Fredensborg Provsti. Erhvervelse og urnenedsættelse er gratis.",
      urne: { erhvervelse: 0, pleje: 786, nedsaettelse: 0 },
      kiste: { erhvervelse: 0, pleje: 1092, nedsaettelse: 0 },
    },
    UDENFOR: {
      label: "Medlem af folkekirken – bosat udenfor provstiet",
      help: "Medlemmer af folkekirken med bopæl udenfor Fredensborg Provsti.",
      urne: { erhvervelse: 235, pleje: 786, nedsaettelse: 787 },
      kiste: { erhvervelse: 620, pleje: 1092, nedsaettelse: 5306 },
    },
    IKKE: {
      label: "Ikke medlem af folkekirken",
      help: "Personer der ikke er medlem af folkekirken.",
      urne: { erhvervelse: 294, pleje: 786, nedsaettelse: 1049 },
      kiste: { erhvervelse: 954, pleje: 1092, nedsaettelse: 7075 },
      kirkeKapel: 1637,
      organist: 1226,
      kirketjener: 1257,
      kor: 768,
    },
  },
};

const optionLabels = {
  erhvervelse: "Erhvervelse af gravsted",
  pleje: "Pleje og vedligehold",
  urnenedsaettelse: "Urnenedsættelse / gravkastning",
  kirkeKapel: "Kirke / kapel",
  organist: "Organist",
  kirketjener: "Kirketjener",
  kor: "Korsangere (pr. stemme)",
};

const cardStyle = {
  background: "#f1f5f9",
  padding: 16,
  borderRadius: 10,
  marginBottom: 16,
};

export default function App() {
  // Fast år (ingen dropdown)
  const rates = priceSets["2026"];

  const [group, setGroup] = useState("BOSAT");
  const [graveType, setGraveType] = useState("urne");
  const [years, setYears] = useState(10);

  const [options, setOptions] = useState({
    erhvervelse: true,
    pleje: false,
    urnenedsaettelse: false,
    kirkeKapel: false,
    organist: false,
    kirketjener: false,
    kor: false,
  });

  const [obligatoriskType, setObligatoriskType] = useState("none");

  // Obligatorisk vedligehold (Humlebæk)
  const obligatoriskOptions = [
    { id: "none", label: "Ingen", types: ["urne", "kiste"] },
    { id: "plæneUrne", label: "Plæne – urne", types: ["urne"] },
    { id: "plæneKiste", label: "Plæne – kiste", types: ["kiste"] },
    { id: "fællesUrne", label: "Fællesanlæg – urne", types: ["urne"] },
  ];

  const obligatoriskPriser = {
    none: 0,
    plæneUrne: 436,
    plæneKiste: 567,
    fællesUrne: 786,
  };

  const toggle = (key) => setOptions({ ...options, [key]: !options[key] });

  const obligatoriskPris = obligatoriskPriser[obligatoriskType] || 0;

  const yearly =
    (options.erhvervelse ? rates[group][graveType].erhvervelse : 0) +
    (options.pleje ? rates[group][graveType].pleje : 0) +
    obligatoriskPris;

  const oneTime =
    (options.urnenedsaettelse ? rates[group][graveType].nedsaettelse : 0) +
    (group === "IKKE" && options.kirkeKapel ? rates[group].kirkeKapel : 0) +
    (group === "IKKE" && options.organist ? rates[group].organist : 0) +
    (group === "IKKE" && options.kirketjener ? rates[group].kirketjener : 0) +
    (group === "IKKE" && options.kor ? rates[group].kor : 0);

  const total = yearly * years + oneTime;

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", padding: 24 }}>
      <div style={{ maxWidth: 720, margin: "0 auto", background: "white", padding: 24, borderRadius: 14 }}>
        <h1 style={{ textAlign: "center", fontSize: 32, fontWeight: 800, marginBottom: 24 }}>
          Humlebæk Kirkegård – prisberegner
        </h1>

        {/* KORT 1 */}
        <div style={cardStyle}>
          <h3 style={{ fontWeight: 700, fontSize: 18, marginBottom: 10 }}>1. Hvem gælder priserne for?</h3>
          {Object.entries(rates).map(([key, g]) => (
            <label key={key} style={{ display: "block", marginBottom: 6 }}>
              <input type="radio" name="group" checked={group === key} onChange={() => setGroup(key)} />{" "}
              {g.label}{" "}
              <span title={g.help} style={{ cursor: "help", color: "#2563eb" }}>?</span>
            </label>
          ))}
        </div>

        {/* KORT 2 */}
        <div style={cardStyle}>
          <h3 style={{ fontWeight: 700, fontSize: 18, marginBottom: 10 }}>2. Gravtype</h3>
          <label>
            <input type="radio" name="grave" checked={graveType === "urne"} onChange={() => setGraveType("urne")} /> Urnegravplads
          </label><br />
          <label>
            <input type="radio" name="grave" checked={graveType === "kiste"} onChange={() => setGraveType("kiste")} /> Kistegravplads
          </label>
        </div>

        {/* KORT 3 */}
        <div style={cardStyle}>
          <h3 style={{ fontWeight: 700, fontSize: 18, marginBottom: 10 }}>3. Hvad skal medregnes?</h3>
          {Object.entries(options).map(([key, val]) => (
            (group === "IKKE" || !["kirkeKapel", "organist", "kirketjener", "kor"].includes(key)) && (
              <label key={key} style={{ display: "block" }}>
                <input type="checkbox" checked={val} onChange={() => toggle(key)} /> {optionLabels[key]}
              </label>
            )
          ))}

          <div style={{ marginTop: 10 }}>
            <strong>Obligatorisk vedligehold:</strong>
            <select
              value={obligatoriskType}
              onChange={(e) => setObligatoriskType(e.target.value)}
              style={{ display: "block", marginTop: 5 }}
            >
              {obligatoriskOptions
                .filter((opt) => opt.types.includes(graveType))
                .map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.label}
                  </option>
                ))}
            </select>
          </div>
        </div>

        {/* KORT 4 */}
        <div style={cardStyle}>
          <h3 style={{ fontWeight: 700, fontSize: 18, marginBottom: 10 }}>4. Samlet overblik</h3>
          <label>
            Antal år:{" "}
            <input type="number" min={1} value={years} onChange={(e) => setYears(Number(e.target.value))} />
          </label>
          <hr />
          <p>Årlig pris: <strong>{yearly} kr</strong></p>
          <p>Engangsydelser: <strong>{oneTime} kr</strong></p>
          <p style={{ fontSize: 18 }}><strong>I alt ({years} år): {total} kr</strong></p>
        </div>

        <p style={{ fontSize: 12, color: "#555" }}>
          Beregningen er vejledende og baseret på gældende takster.
        </p>
      </div>
    </div>
  );
}
